module.exports = __webpack_public_path__ + "img/russian.4259df4e.svg";